import { PropsWithChildren } from 'react'

import { Toolbar } from '../../../features/left-panel/Toolbar'
import { SideBarPhantom } from '../../../common/components/ToolbarItem/SideBarPhantom'
import { SideBarContainer } from '../../../common/components/ToolbarItem/SideBarPortal'

export const ToolbarLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex w-full">
      <SideBarContainer />
      <Toolbar />
      <SideBarPhantom />

      <div className="flex w-full flex-row bg-gray-100">
        <div className="w-full">{children}</div>
      </div>
    </div>
  )
}
